import Error from './Error.container';

export default Error;
